import { Dropdown } from "primereact/dropdown";
import React from "react";
import { useState } from "react";
import { RouteName } from "./RouteName";
import { RouteTypeIndicator } from "./RouteTypeIndicator";
import { useQueryGtfsResource } from "../Queries";

export function RoutePickDropdown({propertyName, initialVal, label, id, onDone, showClear, optionLabel = 'name'}) {
    const [selectedOption, setSelectedOption] = useState(initialVal);
    const {data, isPending, error} = useQueryGtfsResource('routes');

    if (isPending || error) {
        return (<div>...</div>);
    }

    const options = (data) ? Object.values(data) : [];

    const routeOptionTemplate = (option) => {
        const item = option;
        return (
            <div className="flex align-items-center">
                <RouteTypeIndicator GRoute={item} />
                {(item.route_short_name) ? <RouteName GRoute={item} /> : <></>}
                <div className="text-sm">
                    {(item.route_short_name) ? <b>{item.route_long_name}</b> : <b className='hover:text-orange-700' style={{ display: "inline-block", fontWeight: "normal", backgroundColor: '#' + item.route_color, color: '#' + item.route_text_color, borderStyle: 'solid', borderWidth: '0.5pt', padding: '2px', borderColor: '#' + item.route_text_color }}>{item.route_long_name}</b>}
                    {(item.suspended) ? <span className="text-red-200"> zawieszona </span> : <></>}
                    <br />
                    <span className="text-200">{item.network_id}</span>
                </div>
            </div>
        )
    }

    const routeSelectedTemplate = (option, props) => {
        if (option) {
            const item = option;
            return (
                <div className="flex align-items-center">
                    <RouteTypeIndicator GRoute={item} />
                    {(item.route_short_name) ? <RouteName GRoute={item} /> : <></>}
                    <div className="text-sm">
                        {(item.route_short_name) ? <b>{item.route_long_name}</b> : <b className='hover:text-orange-700' style={{ display: "inline-block", fontWeight: "normal", backgroundColor: '#' + item.route_color, color: '#' + item.route_text_color, borderStyle: 'solid', borderWidth: '0.5pt', padding: '2px', borderColor: '#' + item.route_text_color }}>{item.route_long_name}</b>}
                        {(item.suspended) ? <span className="text-red-200"> zawieszona </span> : <></>}
                        <br />
                        <span className="text-200">{item.network_id}</span>
                    </div>
                </div>
            )
        } else {
            return <span>{props.placeholder}</span>
        }

    }

    return (
      <>
          {/* <label htmlFor={id + '-' + propertyName}>{label}</label> */}
          <Dropdown value={selectedOption}
                  inputId={id + '-' + propertyName}  
                  onChange={(e) => {
                      setSelectedOption(e.value);
                      onDone(e.value);
                    }
                  } 
                  options={options} 
                  placeholder="(proszę wybrać)" 
                  className="w-full" 
                  itemTemplate={routeOptionTemplate}
                  valueTemplate={routeSelectedTemplate}
                  showClear={showClear}
                  filter={true}
                  filterBy='route_id,route_short_name,route_long_name'
                  filterInputAutoFocus={true}
                  optionLabel={optionLabel}
                  optionValue='route_id'
                  style={{maxWidth: '437.25px'}}

          />
      </>
    )
}